import { Form, Typography, message } from "antd";
import { useForm } from "antd/es/form/Form";
import OfferStep from "pages/campaign/OfferStep";
import { useLoaderData, useNavigate } from "react-router-dom";
import "./Campaign.scss";
import { CampaignEdit } from "interfaces/campaign-edit";
import { useCallback, useEffect, useMemo, useState } from "react";
import { LocationAvailability } from "interfaces/location-availability";
import {
  checkTierAvailability,
  updateCampaignCompensation,
} from "services/SauceService";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
import { BusinessState } from "redux-context/business";

const CampaignEditOffer: React.FC = () => {
  const campaign = useLoaderData() as CampaignEdit;
  const [loading, setLoading] = useState<boolean>(false);
  const [initialValues] = useState<any>({
    id: campaign._id,
    // minFollowersAmount: campaign.minFollowersAmount || 0,
    // foodComp: campaign.foodComp || 0,
    // compensationTier: campaign.compensationTier,
    venues: campaign.collabsDetatils?.map((collab) => collab.venue) || [],
    creatorCategories: campaign.creatorCategories || [],
    gender: campaign.gender || "",
    dietaryRestrictions: campaign.dietaryRestrictions,
    minRating: campaign.minRating,
    tiers:
      campaign.tiers ||
      [
        // {
        //   _id: "food",
        //   name: "Barter Comp Only",
        //   enabled: true,
        //   minFollowersAmount: 2000,
        //   maxFollowersAmount: 50000,
        //   engagementRate: 1,
        //   foodCompAmount: 50,
        //   minCashCompAmount: 0,
        //   maxCashCompAmount: 0,
        //   guestAllowed: true,
        // },
        // {
        //   _id: "medium",
        //   name: "Medium Comp",
        //   enabled: false,
        //   minFollowersAmount: 10000,
        //   maxFollowersAmount: 100000,
        //   engagementRate: 2,
        //   foodCompAmount: 75,
        //   minCashCompAmount: 30,
        //   maxCashCompAmount: 100,
        //   guestAllowed: true,
        // },
        // {
        //   _id: "large",
        //   name: "Large Comp",
        //   enabled: false,
        //   minFollowersAmount: 50000,
        //   maxFollowersAmount: 500000,
        //   engagementRate: 2,
        //   foodCompAmount: 100,
        //   minCashCompAmount: 100,
        //   maxCashCompAmount: 200,
        //   guestAllowed: true,
        // },
      ],
  });
  const [locationAvailability, setLocationAvailability] =
    useState<LocationAvailability>();
  const [form] = useForm();
  const navigate = useNavigate();
  const { business } = useSelector((state: BusinessState) => state.business);

  const handleSubmit = async () => {
    const values = form.getFieldsValue(true);
    setLoading(true);
    const response = await updateCampaignCompensation(values);
    if (response) {
      message.success("Campaign offer updated successfully");
      navigate("/campaigns");
    } else {
      message.error("Failed to update campaign offer");
    }
    setLoading(false);
  };

  const handleValueChange = useCallback(async () => {
    const {
      venues,
      minFollowersAmount,
      foodComp,
      socialMediaName,
      creatorCategories,
      gender,
      dietaryRestrictions,
      minRating,
      tiers,
    } = form.getFieldsValue(true);
    if (venues?.length > 0 && business._id) {
      setLoading(true);
      try {
        const response: any = await checkTierAvailability({
          businessId: business._id,
          venues,
          minFollowersAmount,
          foodComp,
          socialMediaName,
          categories: creatorCategories,
          gender,
          dietaryRestrictions,
          minRating,
          tiers,
        });
        setLocationAvailability(response);
      } catch (error: any) {
        console.error("Error checking location availability:", error);
        message.error(
          error?.response?.data?.message ||
            "Failed to check location availability"
        );
      } finally {
        setLoading(false);
      }
    }
  }, [form, business]);

  const handleValueChangeDebounced = useMemo(
    () => debounce(handleValueChange, 400),
    [handleValueChange]
  );

  useEffect(() => {
    handleValueChange();
  }, [handleValueChange]);

  return (
    <div className="campaign create">
      <Typography.Title level={3} style={{ fontSize: 32, margin: 0 }}>
        Edit Campaign Offer
      </Typography.Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={initialValues}
      >
        <OfferStep
          form={form}
          loading={loading}
          showSocialMediaName={false}
          locationAvailability={locationAvailability}
          handleValueChange={handleValueChange}
          handleValueChangeDebounced={handleValueChangeDebounced}
          onClickNext={() => form.submit()}
          onClickBack={() => navigate("/campaigns")}
          textNext="Update"
        />
      </Form>
    </div>
  );
};

export default CampaignEditOffer;
